import React, { FC, ReactElement, Fragment } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'components/Breadcrumbs/Breadcrumbs.module.scss';

const cn = classNames.bind(styles);

interface BreadcrumbsProps {
  links: LinkType[];
  mode: 'light' | 'dark';
  mTop?: number;
}

type LinkType = {
  title: string;
  href: Route;
};

const Breadcrumbs: FC<BreadcrumbsProps> = ({ links, mode, mTop }): ReactElement => {
  return (
    <div
      className={cn('breadcrumbs', `${mode}`)}
      style={mTop ? { marginTop: mTop } : {}}
    >
      <Link href="/">Home page</Link> /
      {links.map((item) =>
        !!item.href ? (
          <Fragment key={item.title}>
            <Link href={item.href}>{item.title}</Link> /
          </Fragment>
        ) : (
          <span className={cn('breadcrumbs__last-item')} key={item.title}>
            {item.title}
          </span>
        )
      )}
    </div>
  );
};

export default Breadcrumbs;
